import React, { memo } from "react";
import { toDollarFormat, diffInDays, invertDayAndMonth } from "react/utils/utils";

import { AccordionList, Accordion, Flex, Text } from 'onefaceui-react-components';

const LocationPendingPayment = ({ locationPendingPaymentArray, i18n }) => {
  let locationMap = {};
  const soldString = i18n.getResourcesByKey("route.data.payment.sold");
  const dueString = i18n.getResourcesByKey("route.data.payment.due");

  locationPendingPaymentArray.map(item => {
    const { id, description, addressLine1, key } = item.location;
    const {
      documentKey,
      amount,
      amountPayed,
      dueDate,
      saleDate,
      remark
    } = item;

    if (locationMap[id]) {
      locationMap[id].infos.total += amount;
      locationMap[id].payments.push({
        documentKey,
        amount,
        amountPayed,
        dueDate,
        saleDate,
        remark
      });
    } else {
      locationMap[id] = {
        infos: { key, description, addressLine1, total: amount },
        payments: [
          { documentKey, amount, amountPayed, dueDate, saleDate, remark }
        ]
      };
    }
  });

  const locationList = Object.values(locationMap).map(item =>
    <Accordion
      key={item.infos.key}
      customHeaderComponent={
        <Flex
          style={{ flex: 1 }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex flexDirection="column">
            <Text type="primary" overflow="ellipsis">{item.infos.description || item.infos.key}</Text>
            <Text size="xs" overflow="ellipsis">
              {item.infos.addressLine1 ? `${item.infos.key} - ${item.infos.addressLine1}` : item.infos.key}
            </Text>
          </Flex>
          <Text type="primary" weight="bold">{toDollarFormat(item.infos.total)}</Text>
        </Flex>
      }
    >
      {item.payments.map(invoice => {
        const dueDateInverted = invertDayAndMonth(invoice.dueDate);
        const saleDateInverted = invertDayAndMonth(invoice.saleDate);
        const days = diffInDays(invoice.dueDate);
        const color = days >= 0 ? "positive" : "negative";
        const invoiceItemClassName = days >= 0
          ? "gmfont-sizes-icon-check positive"
          : "gmfont-sizes-icon-ringing-bell negative";
        return (
          <div>
            <div className="payments">
              <div className="documentKey">
                <div className="symbol">
                  <span className={`${invoiceItemClassName}`} />
                  <div className={`days ${color}`}>{Math.abs(days)}</div>
                </div>
                <div className="containerInvoiceDate">
                  <div className="invoice">{invoice.documentKey}</div>
                  <div className="date">{`${soldString}: ${saleDateInverted} - ${dueString}: ${dueDateInverted}`}</div>
                </div>
              </div>
              <div className="amount">
                {toDollarFormat(invoice.amount)}
              </div>
            </div>
            {invoice.amountPayed
              ? <div className="partialPaymentContainer">
                  <div className="partialPayment">
                    {i18n.getResourcesByKey(
                      "route.data.payment.partialPayment"
                    )}
                  </div>
                  <div className="value">
                    {toDollarFormat(invoice.amountPayed)}
                  </div>
                </div>
              : null}
          </div>
        );
      })}
    </Accordion>
  );

  return (
    <div id="locationPendingPaymentsContainer">
      <AccordionList
        className="locationPendingPaymentsAccordion"
        size="md"
        allowMultipleExpanded
      >
        {locationList}
      </AccordionList>
    </div>
  );
};

export default memo(LocationPendingPayment);
